import { render, staticRenderFns } from "./ItemProdutoListFilters.vue?vue&type=template&id=464dbda6&"
import script from "./ItemProdutoListFilters.vue?vue&type=script&lang=js&"
export * from "./ItemProdutoListFilters.vue?vue&type=script&lang=js&"
import style0 from "./ItemProdutoListFilters.vue?vue&type=style&index=0&id=464dbda6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports